export const cifLt = ["301 181","<g fill-rule='nonzero' fill='none'><path fill='#FDB913' d='M.5.5h300v180H.5z'/><path fill='#C1272D' d='M.5 90.5h300v90H.5z'/><path fill='#006A44' d='M.5 60.5h300v60H.5z'/></g>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/flag/cif-lt.js
// module id = null
// module chunks = 